import styled from 'styled-components'

export const SmallContainer = styled.div`
  width: 1000px;
  margin: 0 auto;
  padding: 50px 0;
  @media (max-width: 1050px) {
    width: 90%;
    padding: 30px 0;
  }
`

export const MinimalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`

export const MobileBookNow = styled.div<{ active: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 3;
  background: ${({ theme }) => theme?.colourPalette?.primaryColour || 'white'};
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  transform: translateY(100%);
  transition: 0.25s ease-in-out;
  display: flex;
  opacity: 0;

  @media (max-width: 767px) {
    display: flex;
  }

  ${({ active }) =>
    active &&
    `
    transform: translateY(0);
    opacity: 1;
  `}
`

export const Currency = styled.span`
  font-size: 12px;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`

export const FromPrice = styled.div`
  color: var(--grey-100);
  font-size: 13px;
  font-weight: var(--font-regular);
  margin-bottom: 6px;

  & > span {
    text-decoration: line-through;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`

export const Price = styled.span`
  font-weight: var(--font-medium);
  font-size: 28px;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 25px;
  }
`

export const PricingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-shrink: 0;
`

export const MinimalPricing = styled.div<{ onSale: boolean }>`
  ${({ onSale }) =>
    onSale &&
    `
    ${Price},
    ${Currency} {
      color: var(--sale);
    }
  `}

  @media (max-width: 768px) {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    gap: 4px;
  }
`
